import React from 'react';
import PropTypes from 'prop-types';
import { AssetPropType } from 'public/schema';
import { useClassName } from 'common/hooks';
import { LoaderImage } from '../../Loader';
import './landing-hero-logo.less';

const LandingHeroLogo = ({ asset }) => {
  const className = useClassName('LandingHeroLogo');

  return (
    <div className={className('container')}>
      {asset && (
        <LoaderImage
          src={asset.assetUrl}
          alt={asset.assetAlt}
          loadingHeight={50}
          fluid
          hideLoader
        />
      )}
    </div>
  );
};

LandingHeroLogo.propTypes = {
  asset: PropTypes.shape(AssetPropType).isRequired,
};

export default LandingHeroLogo;
